import api from './api';

export interface AuthUser {
  id: string;
  login: string;
  fullName: string;
  role: string;
  phone?: string | null;
  avatar?: string | null;
  tenantId?: string | null; // SaaS: null = platforma superadmini
  tenantSlug?: string | null; // subdomen (yo'naltirish/branding)
  tenantName?: string | null; // MAKTAB nomi — panel sarlavhasida shu ko'rinadi
}

export const authService = {
  async login(login: string, password: string) {
    const { data } = await api.post<{ token: string; user: AuthUser }>('/auth/login', { login, password });
    localStorage.setItem('sata_token', data.token);
    localStorage.setItem('sata_user', JSON.stringify(data.user));
    return data;
  },

  /** Joriy foydalanuvchini serverdan oladi (/auth/me) va localStorage'ni yangilaydi. */
  async me(): Promise<AuthUser | null> {
    const { data } = await api.get<AuthUser | null>('/auth/me');
    if (data?.id) localStorage.setItem('sata_user', JSON.stringify(data));
    return data;
  },

  logout() {
    localStorage.removeItem('sata_token');
    localStorage.removeItem('sata_user');
  },

  getToken() {
    return localStorage.getItem('sata_token');
  },

  getUser(): AuthUser | null {
    const raw = localStorage.getItem('sata_user');
    return raw ? (JSON.parse(raw) as AuthUser) : null;
  },

  /** Saqlangan foydalanuvchini qisman yangilaydi (masalan avatar). */
  patchUser(patch: Partial<AuthUser>): AuthUser | null {
    const current = this.getUser();
    if (!current) return null;
    const next = { ...current, ...patch };
    localStorage.setItem('sata_user', JSON.stringify(next));
    return next;
  },
};
